import './style/index.css';
import 'babel-polyfill'; 
import App from './components/app';

export default App;
